<template>
  <div v-loading="loading">
    <div class="m-20">
      <el-row>
        <el-col :span="18">
          <span class="fs-14 mr-10">Filtrer les étiquettes de produits : </span>
          <el-radio-group v-model="filter.active" size="small" :disabled="isFreezed">
            <el-radio-button :label="true">Active(s)</el-radio-button>
            <el-radio-button :label="false">Inactive(s)</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="6" class="text-right">
          <el-button type="primary" size="small" @click="addNewTag"><i class="mdi mdi-plus-circle"><span class="pl-5">Nouveau</span></i> </el-button>
        </el-col>

      </el-row>
    </div>
    <div v-if="addingTag==true" class="m-20 border p-20 bg-accent-lighter" >
      <el-row>
        <el-col :span="18">
          <span class="fs-14"> Nouvelle étiquette : </span><el-input v-model="newTag.code" style="width:300px;" size="small"></el-input>
        </el-col>
        <el-col :span="6" class="text-right">
          <el-button :disabled="false"
            size="mini"
            type="success"
            @click="saveNewTag"
            circle
            ><i class="mdi mdi-check fs-14" ></i></el-button>
          <el-button :disabled="false"
            size="mini"
            @click="cancelNewTag"
            type="info"
            circle
            ><i class="mdi mdi-cancel fs-14" ></i></el-button>
        </el-col>
      </el-row>
    </div>
    <div class="box grow scrollable only-y" :style="getHeightStyle">
      <draggable v-if="filter.active==true" v-model="activeTags" handle=".handle" :move="onMove" v-bind="dragOptions" @start="drag = true" @end="drag = false" @change="orderChange">
        <transition-group type="transition" :name="'flip-list'">
          <div v-for="(tag, index) in activeTags" :key="tag.order_" class="p-5 border m-5" :class="{'bg-accent-lighter' : editionIndex==index}">
            <el-row type="flex">
              <el-col :span="18" class="m-5">
                <i class="mdi mdi-drag handle" v-if="orderable"  @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                <i class="mdi mdi-drag" v-else  aria-hidden="true"></i>
                <span class="fs-14 ml-20" v-if="editionIndex!=index">{{tag.code}} <span class="fs-12 secondary-text">({{tag.count}})</span></span>
                <el-input v-else v-model="editedTag.code" size="small" class="m-0 ml-20" style="width:300px;"></el-input>
                <el-radio-group class="ml-20" v-model="editedTag.active" v-if="editedTag != null && editionIndex==index" size="mini">
                  <el-radio-button :label="true">Active</el-radio-button>
                  <el-radio-button :label="false">Inactive</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="6" class="text-right align-vertical-middle">
                <el-button
                  v-if="editionIndex!=index"
                  :disabled="editedTag!=null || !editable"
                  size="mini"
                  circle
                  @click="handleEdition(index)"
                  ><i class="mdi mdi-lead-pencil fs-14"></i></el-button>
                <el-button
                  v-if="editionIndex!=index"
                  :disabled="editedTag!=null || !editable"
                  size="mini"
                  type="danger"
                  @click="deleteTag(tag)"
                  circle
                  ><i class="mdi mdi-delete fs-14" ></i></el-button>
                <el-button :disabled="false"
                  v-if="editionIndex==index"
                  size="mini"
                  type="success"
                  @click="applyChange"
                  circle
                  ><i class="mdi mdi-check fs-14" ></i></el-button>
                <el-button :disabled="false"
                  v-if="editionIndex==index"
                  size="mini"
                  @click="cancel"
                  type="info"
                  circle
                  ><i class="mdi mdi-cancel fs-14" ></i></el-button>
              </el-col>
            </el-row>
          </div>
        </transition-group>
      </draggable>
      <div v-else>
        <div v-for="(tag, index) in inactiveTags" :key="tag.id" class="p-5 border m-5">
          <el-row type="flex">
            <el-col :span="18" class="m-5">
              <span class="fs-14 ml-20" v-if="editionIndex!=index">{{tag.code}} <span class="fs-12 secondary-text">({{tag.count}})</span></span>
              <el-input v-else v-model="editedTag.code" size="small" class="m-0 ml-20" style="width:300px;"></el-input>
              <el-radio-group class="ml-20" v-model="editedTag.active" v-if="editedTag != null && editionIndex==index" size="mini">
                <el-radio-button :label="true">Active</el-radio-button>
                <el-radio-button :label="false">Inactive</el-radio-button>
              </el-radio-group>
            </el-col>
              <el-col :span="6" class="text-right align-vertical-middle">
              <el-button
                v-if="editionIndex!=index"
                size="mini"
                circle
                @click="handleEdition(index)"
                ><i class="mdi mdi-lead-pencil fs-14"></i></el-button>
              <el-button :disabled="false"
              v-if="editionIndex!=index"
                size="mini"
                type="danger"
                @click="deleteTag(tag)"
                circle
                ><i class="mdi mdi-delete fs-14" ></i></el-button>
              <el-button :disabled="false"
                v-if="editionIndex==index"
                size="mini"
                type="success"
                @click="applyChange"
                circle
                ><i class="mdi mdi-check fs-14" ></i></el-button>
              <el-button :disabled="false"
                  v-if="editionIndex==index"
                  size="mini"
                  @click="cancel"
                  type="info"
                  circle
                  ><i class="mdi mdi-cancel fs-14" ></i></el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SystemAPI from '@/services/API/system'
import draggable from 'vuedraggable';

export default {
  name: 'TagListingEditor',
  props: {
    type : String
	},
  data() {
    return {
      addingTag : false,
      newTag : {
        code : null,
        type : null
      },
      orderable : true,
      editable : true,
      activeTags : [],
      inactiveTags : [],
      loading : true,
      filter : {
        active : true
      },
      drag : false,
      editionIndex : null,
      editedTag : null,
      window: {
				width: 0,
				height: 0
			}
    };
  },components: {
    draggable
  },
	methods: {
    cancelNewTag(){
      this.editable = true;
      this.addingTag = false;
      this.orderable = true;
    },
    saveNewTag(){
      this.loading = true;
      return SystemAPI.postTag({code : this.newTag.code, type : this.type})
        .then(tag=>{
          this.fetchTags();
          this.$message({
            type: 'success',
            message: 'Étiquette sauvegardée'
          });
          this.editable = true;
          this.addingTag = false;
          this.loading = false;
          this.orderable = true;
          this.newTag.code = null;
          this.newTag.type = null;
        })
    },
    addNewTag(){
      this.editable = false;
      this.addingTag = true;
      this.orderable = false;
    },
    count(tag){
      if(this.type=='PRODUCT')return tag.product_count;
      if(this.type=='CUSTOMER')return tag.customer_count;
      if(this.type=='SALES_ORDER')return tag.sales_order_count;
      if(this.type=='CONTACT')return tag.contact_count;
    },
    deleteTag(tag){

      let message = tag.count>0 ? `Certains documents (`+tag.count+`) sont associés à cette étiquette. Ceci supprimera l'association ainsi que l'étiquette. Continuer?` : `Ceci supprimera définitivement l'étiquette. Continuer?`


      this.$confirm(message, 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          return SystemAPI.deleteTag(tag.id)
            .then(()=>{
              this.fetchTags();
              this.$message({
                type: 'success',
                message: 'Étiquette supprimée'
              });
            })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Suppression annulée'
          });
        });
    },
    applyChange(){
      this.loading=true;
      return SystemAPI.updateTag(this.editedTag.id, {code:this.editedTag.code, active:this.editedTag.active, type : this.editedTag.type, order_:this.editedTag.order_})
        .then(tagUpdated=>this.fetchTags())
        .then(()=>{
          this.editionIndex = null;
          this.editedTag = null;
          this.loading = false;
          this.orderable = true;
          this.$message({
            type: 'success',
            message: 'Modification effectuée'
          });
        })
    },
    cancel(){
      this.editionIndex = null;
      this.editedTag = null;
      this.orderable = true;
    },
    handleEdition(index){
      this.orderable = false;
      this.editedTag = _.cloneDeep(this.filter.active==true?this.activeTags[index]:this.inactiveTags[index]);
      this.editionIndex = index
    },
    orderChange(test){
      _.forEach(this.activeTags, (t, index)=>{t.order_ = index+1})
      return SystemAPI.updateTags(this.activeTags)

    },
    fetchTags(){
      this.loading= true;
      return SystemAPI.getTags(this.type)
        .then(tags=>{
          _.forEach(tags, tag => {
            if (tag._order == null) {
              tag.order_ = 100000;
            }
          })
          this.activeTags = _.remove(tags, t=>{return t.active==true});
          this.inactiveTags = tags;
          this.loading = false;
        })
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
	},
	computed: {
    isFreezed(){
      return this.addingTag==true || this.loading == true || this.editedTag!=null
    },
    getHeight(){
      return (this.window.height-330);
    },
    getHeightStyle(){
      return "height:" + this.getHeight + "px;";
    },
    dragOptions() {
      return {
        animation: 200,
        group: "code",
        disabled: !this.orderable,
        ghostClass: "ghost"
      };
    }
	},
  mounted(){
    this.fetchTags()
      .then(()=>{
        this.loading= false;
      })
  },
  created(){
    this.handleResize();
  }
}
</script>
<style lang="scss" scoped>

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.handle {
    cursor: move; /* fallback if grab cursor is unsupported */
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.handle:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
}
</style>
